import React, { Component } from 'react'
import styled from 'styled-components'
import Transition from 'react-transition-group/Transition'

import responsive from '../utils/responsive'
import Button from './Button'

import AppScreenSrc from '../images/tab-ipsum-sample.gif'

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 10vw;
  @media(max-width: 680px) {
    min-height: 0;
  }
`

const WhiteBox = styled.div`
  content: '';
  width: 30vw;
  height: 100%;
  background-color: #FFFFFF;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  opacity: 0;
  transition: opacity .6s ease 800ms, transform .6s ease 800ms;
  transform: translateX(6vw);
  @media(max-width: 680px) {
    display: none;
  }
`

const ContentLeft = styled.div`
  flex: 1;
`
const ContentRight = styled.div`
  flex: 1;
  @media(max-width: 680px) {
    display: none;
  }
`

const Title = styled.h1`
  font-size: ${responsive(32, 60, 320, 1280)};
  letter-spacing: -3px;
  color: #FFFFFF;
  font-weight: 300;
  transition: opacity .6s ease, transform .6s ease;  
  opacity: 0;
  transform: translateY(20px);
  @media(max-width: 680px) {
    line-height: 1;
  }
`

const AppScreen = styled.img`
  max-width: 315px;
  width: 35vw;
  height: auto;
  position: relative;
  z-index: 3;
  left: 11vw;
  box-shadow: 0px 0px 70px rgba(0, 0, 0, 0.3);
  transition: opacity .9s ease 1000ms, transform .9s ease 1000ms;
  transform: translateX(6vw);
  opacity: 0;
`

const Soon = styled.div`
  margin-top: 25px;
  font-size: 12px;
  font-weight: 300;
  color: #828282;
  transition: opacity .6s ease 400ms, transform .6s ease 400ms;
  opacity: 0;
  transform: translateY(20px);

  a {
    color: #FFF;
    text-decoration: none;
  }
`

const transitionStyles = {
  entered:  {
    opacity: 1,
    transform: 'translateY(0)'
  },
}

const appTransitionStyles = {
  entered: {
    opacity: 1,
    transform: 'translateX(0)'
  }
}

class Cover extends Component {
  render () {
    return (
      <Transition in={this.props.loaded} timeout={500}>
        {(state) => (
          <Container>
            <ContentLeft>
              <Title style={{...transitionStyles[state]}}>Easily generate fake content.</Title>
              <Button loaded={this.props.loaded} timeout={700}/>
              <Soon style={{...transitionStyles[state]}}>Also available for <a href="https://chrome.google.com/webstore/detail/tabipsum/kodnpaacnfpgeakliedgocnfoeiajghp?hl=gl" target="_blank" rel="noopener noreferrer">Chrome</a> and soon for Firefox and Windows.</Soon>
            </ContentLeft>
            <ContentRight>
              <div>
                <AppScreen style={{...appTransitionStyles[state]}} src={AppScreenSrc} />
              </div>
            </ContentRight>
            <WhiteBox style={{...appTransitionStyles[state]}} />
          </Container>
        )}
      </Transition>
    )
  }
}

export default Cover


// WEBPACK FOOTER //
// ./src/components/Cover.jsx